import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNoFlash"><Path fillRule="evenodd" clipRule="evenodd" d="M14.0004 0.212402V7.99999H21.4823L16.2772 15.157L22.205 20.4608L21.5382 21.206L1.79297 3.53922L2.45976 2.79398L8.31366 8.03168L14.0004 0.212402ZM9.06272 8.70189L13.0004 3.28759V8.99999H19.5185L15.5282 14.4867L9.06272 8.70189Z" fill="currentColor"/><Path d="M14.3462 16.112L15.0952 16.7822L10.0004 23.7876V16H2.51852L7.13167 9.65691L7.88073 10.3271L4.48229 15H11.0004V20.7124L14.3462 16.112Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNoFlash;
